export type GraphQLFragment = { name: string; fragment: string };
export const DEFAULT_GRAPHQL_FRAGMENT: GraphQLFragment = { name: '', fragment: '' };
